import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {AppComponent} from '../app.component';
import {cloneDeep} from "lodash";

@Component({
	selector: 'app-mdp-rappel',
	templateUrl: './mdp-rappel.component.html',
	encapsulation: ViewEncapsulation.None,
	styleUrls: ['./mdp-rappel.component.less']
})
export class MdpRappelComponent implements OnInit {
	textes: any = null;
	modalsTxt: any = null;
	globalTxt: any;
	submitted: boolean = false;
	forgotPassword!: FormGroup;

	get f() {
		return this.forgotPassword.controls;
	}

	constructor(
		public app: AppComponent,
		private formBuilder: FormBuilder
	) {
	}

	ngOnInit(): void {
		this.forgotPassword = this.formBuilder.group(
			{
				Email: ['', [Validators.required, Validators.email]],
			}
		)
		// Get the global texts
		this.app.dataInitService.getGlobalTextsOnce(globalTxt => {
			this.globalTxt = globalTxt;
			console.log("this.globalTxt ==> ", this.globalTxt);

			// Get the modal texts
			this.app.dataInitService.getModalTextsOnce(modalsTxt => {
				this.modalsTxt = modalsTxt;
				console.log("this.modalsTxt ==> ", this.modalsTxt);
			});

			// Load the texts for the forgot password page
			this.app.sharedToolsService.loadTexts('txtLoginMdpOublie')
				.subscribe(textes => {
					this.textes = textes;
					console.log("this.textes ==> ", this.textes);
				});
		});
	}

	onSubmit() {
		console.log("--------", this.forgotPassword.value.Email);
		this.submitted = true;

		if (this.forgotPassword.value.Email == '' || this.forgotPassword.invalid) {
			return;
		} else {
			this.app.apiToolsService.forgotPassword(this.forgotPassword.value.Email).subscribe(
				(res: any) => {
					console.log("res===", res);
					if (res == true) {
						this.app.confirmDialogService.confirmThis("", this.modalsTxt.modalResetPassword, "alert", "", () => {
							this.app.router.navigate(['/'])
						}, () => {
						});
					}
				}, err => {
					console.error('forgotPassword Error ==> ', err)
					if (err.status === 404) {
						this.app.confirmDialogService.confirmThis("", this.modalsTxt.modalResetPassword, "alert", "", () => {
							this.app.router.navigate(['/'])
						}, () => {
						});
					}
				})
		}
	}
}
